import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserDataService } from '../services/userDataService';
import rustleLogo from '../images/rustle_it_logo.png';

const SetupPin: React.FC = () => {
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setError(null);
    if (!/^\d{4}$/.test(pin)) {
      setError('PIN must be exactly 4 digits.');
      return;
    }
    if (pin !== confirmPin) {
      setError('PINs do not match.');
      return;
    }
    setIsSubmitting(true);
    try {
      await UserDataService.setupMyPin(pin);
      navigate('/select-org');
    } catch {
      setError('Failed to set PIN. Please try again.');
      setIsSubmitting(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleSubmit();
  };

  return (
    <div className="rustle-background" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="d-flex flex-column align-items-center" style={{ position: 'relative', zIndex: 1 }}>
        <img src={rustleLogo} alt="Rustle" className="logo" />

        <div
          style={{
            background: 'rgba(255,255,255,0.35)',
            borderRadius: 16,
            boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
            padding: '2.5rem 3rem',
            textAlign: 'center',
            minWidth: 340,
          }}
        >
          <h2 className="font-primary mb-1">Set up your PIN</h2>
          <p className="text-muted mb-4" style={{ maxWidth: 280 }}>
            Choose a 4-digit PIN you'll use to sign in on shared devices.
          </p>

          <input
            type="password"
            inputMode="numeric"
            pattern="\d*"
            className="form-control mb-3"
            placeholder="Enter 4-digit PIN"
            value={pin}
            onChange={e => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
            onKeyDown={handleKeyDown}
            disabled={isSubmitting}
            maxLength={4}
          />
          <input
            type="password"
            inputMode="numeric"
            pattern="\d*"
            className="form-control mb-3"
            placeholder="Confirm PIN"
            value={confirmPin}
            onChange={e => setConfirmPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
            onKeyDown={handleKeyDown}
            disabled={isSubmitting}
            maxLength={4}
          />

          {error && <div className="alert alert-danger py-2 mb-3">{error}</div>}

          <button
            className="btn btn-primary w-100"
            onClick={handleSubmit}
            disabled={isSubmitting || pin.length < 4}
          >
            {isSubmitting ? 'Saving…' : 'Set PIN & continue'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SetupPin;
